module.exports = __webpack_public_path__ + "img/post2.24e981fd.png";